import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import _ from "lodash";
import Schemas from "schemas";

import PopUpWrapper from "./modal-wrapper";

import { Control } from "components/ui-kit/control";
import { Button, Form, Row } from "components/ui-kit/styled-templates";

import { CURRENCIES, ROOM_TYPES } from "constants/config";

import RoomsApi from "api/rooms-api";

import useFormControl from "hooks/useFormControl";
import useModal from "hooks/useModal";

import { EForms, EModals, ESteps } from "types/enums";



const EditRoomModal = () => {
    const { t } = useTranslation();

    const { dormitoryId } = useParams();

    const { data: formData, onSubmit, clearForm, setValues } = useFormControl({ name: EForms.editRoom, schema: Schemas[EForms.editRoom] });
    const { close, state: modalState = {} } = useModal(EModals.EditRoom, {
        onOpen: ({ data = {} }: any) => {
            console.log('onOpen: data = ', data);
            setValues(data?.details ?? {isAlwaysAvailable: true})
        },
    });
    const { mode, data } = modalState;

    const anyChanges = !_.isEqual(data?.details, formData);

    const handlers = {
        submit: async (details: any) => {
            if (dormitoryId) {
                if (mode === `create`) {
                    await RoomsApi.createRoom(dormitoryId, details);
                } else {
                    await RoomsApi.updateRoom({ ...data, details });
                }
                close();
            }
        },
    };

    // console.log('modal: data = ', data);
    // console.log('modal: formData = ', formData);
    let isAlwaysAvailable = (formData?.isAlwaysAvailable == undefined ? false : formData?.isAlwaysAvailable);
    console.log('--->>> isAlwaysAvailable = ', isAlwaysAvailable);

    return (
        <PopUpWrapper name={EModals.EditRoom} onClose={clearForm}>
            <Form name={EForms.editRoom} onSubmit={onSubmit(handlers.submit)} extra={`h3 { margin-top: 0; };`}>
                <h3>{mode === `edit` ? `Редактирование помещения` : `Создание помещения`}</h3>
                <Control.Row>
                    <Control.Select name="type" label={t("q7m52xp9kr")} options={ROOM_TYPES.map((i) => ({ value: i, label: i }))} isRequired />
                    <Control.Wrapper />
                </Control.Row>
                <Control.Row>
                    <Control.Input name="amount" placeholder="3" label={t("4s22vqjqsj6")} regex="[^0-9]" extra={`flex: 2;`} isRequired />
                    <Control.Input name="price" placeholder="0" label={t("y9h1hfw72v")} regex="[^0-9]" extra={`flex: 3;`} isRequired />
                    <Control.Select name="currency" extra={`flex: 3;`}  label={'Валюта'} options={CURRENCIES.map((i) => ({ value: i, label: i }))} isRequired />
                    <Control.Switch name="isFree" label={t("ue0dyd6rpae")} extra="justify-content: flex-start; flex: 2;" />
                </Control.Row>
                <Control.Row>
                    <div style={{opacity: (isAlwaysAvailable == false ? 1 : 0.5)}} >
                        <Control.DateRange name="dateRange" label={t("vmdcy4xzt4a")} placeholder={t("497w70tqc38")} />
                    </div>
                    <div style={{flex: 1}} >
                        <Control.Switch name="isAlwaysAvailable" label={'Доступно всегда'} extra="justify-content: flex-start; flex: 2;" />
                    </div>
                    {/*<div style={{flex: 1}} >*/}
                    {/*    <Control.Switch name="isInclusive" label={'Инклюзивно'} extra="justify-content: flex-start; flex: 2;" />*/}
                    {/*</div>*/}
                </Control.Row>


                <Control.Textarea name="description" placeholder={t("whnm50kr9qj")} label={t("n9bstfwbifj")} isRequired />

                <Control.File multiple
                              name="photos"
                              dropzoneProps={{ label: `Загрузить фотографию (размер не более 2Мб, формат JPG, PNG)`}}
                              label={`Загрузить фотографию (рекомендуемые размеры Ширина = 1000 пикселей, Высота = 600 пикселей)`}
                              isRequired />

                {/*<Control.File multiple name={`${ESteps.MainInfo}.photos`}*/}
                {/*              dropzoneProps={{ label: `Загрузить фотографию (размер не более 2Мб, формат JPG, PNG)`}}*/}
                {/*              label={`Загрузить фотографию (рекомендуемая пропорция Ширина:Высота = 5:3)`} isRequired />*/}

                <Control.File
                    multiple
                    name="video"
                    label={t("gl7kyrcr1d9")}
                    dropzoneProps={{ label: `Загрузить видео (не более 100Мб, формат MP4)`, icon: `dropzone-video` }}
                    accept="video/mp4, video/quicktime"
                />

                {anyChanges && <Control.Error extra={`margin-bottom: 15px;`}>{t("i1e0ggy2mv")}</Control.Error>}

                <Row extra={`width: inherit; justify-content: flex-end; gap: 10px;`}>
                    <Button variant="outlined" background="gray" onClick={close}>
                        {t("pdfz239w349")}
                    </Button>
                    <Button type="submit" background="green">
                        {t("anoi4xbmv")}
                    </Button>
                </Row>
            </Form>
        </PopUpWrapper>
    );
};

export default EditRoomModal;
